export type Metadata = {
  title?: string;
  description?: string;
};

const ERROR_PAGE_METADATA = {
  302: {
    title: '302 Content not Found | i3D.net - Controlpanel',
    description: 'Oops! This content is not available at the moment… Do you need assistance? Our Customer Support Team is happy to assist.',
  },
  400: {
    title: '400 Bad Request | i3D.net - Controlpanel',
    description: '',
  },
  401: {
    title: '401 Unauthorized Error | i3D.net - Controlpanel',
    description: 'Oops! Something went wrong… Do you need assistance? Our Customer Support Team is happy to assist.',
  },
  403: {
    title: '403 Forbidden | i3D.net - Controlpanel',
    description: 'Oops! Something went wrong… Do you need assistance? Our Customer Support Team is happy to assist.',
  },
  404: {
    title: 'Page not found | i3D.net - Controlpanel',
    description: '',
  },
  410: {
    title: '410 Content Removed | i3D.net - Controlpanel',
    description: 'Oops! We have removed the content you’re looking for… Do you need assistance? Our Customer Support Team is happy to assist.',
  },
  500: {
    title: 'HTTP Error 500 | i3D.net - Controlpanel',
    description: 'Oops! Something went wrong… Do you need assistance? Our Customer Support Team is happy to assist.',
  },
} as const;

export default ERROR_PAGE_METADATA;
